// Mounts the OGS render path the BUNDLE asks for: scene.json render_settings, else the current one.
// Notes: ~/comments/aos-threejs-poc/OGSAvatar_probe_then_mount.md

import { useEffect, useState } from 'react'
import MultipartOGSModel from '../MultipartOGSModel'
import NextOGSAvatar from './NextOGSAvatar'
import { listOgsAssets, cachedFetchAamFile } from '../../lib/assetManagerApi.js'
import { probeRenderSettings } from '../../ogs/pipeline/renderSettingsProbe.ts'
import { LEGACY_SETTINGS, describeRenderSettings } from '../../ogs/pipeline/renderSettings.ts'
import { renderPathDebug } from '../../ogs/pipeline/debugSchema.ts'
import { publishDebug, retractDebug } from '../../ogs/pipeline/ogsDebug.ts'
import { createOgsLogger } from '../../ogs/pipeline/ogsLog.ts'

// assetManagerApi owns the endpoint; the probe only reads the URL the row hands back.
const PROBE_DEPS = { listOgsAssets, fetchFile: cachedFetchAamFile }

export default function OGSAvatar({ characterId = null, ...props }) {
  // null while the bundle has not answered — neither path may mount on a guess.
  const [settings, setSettings] = useState(null)

  useEffect(() => {
    let cancelled = false
    setSettings(null)
    publishDebug('__OGS_RENDER_PATH__', renderPathDebug(LEGACY_SETTINGS, characterId, 'probing'))
    probeRenderSettings(characterId, PROBE_DEPS)
      .then((resolved) => {
        if (cancelled) return
        const log = createOgsLogger({ level: resolved.logging })
        if (resolved.error) log.error(`'${characterId ?? 'unknown'}': ${describeRenderSettings(resolved)}`)
        else log.info(`'${characterId ?? 'unknown'}': ${describeRenderSettings(resolved)}`)
        publishDebug('__OGS_RENDER_PATH__', renderPathDebug(resolved, characterId, 'resolved'))
        setSettings(resolved)
      })
    return () => {
      cancelled = true
      retractDebug('__OGS_RENDER_PATH__')
    }
  }, [characterId])

  if (!settings) return null
  if (settings.path === 'next') return <NextOGSAvatar {...props} settings={settings} slug={characterId} />
  return <MultipartOGSModel {...props} />
}
